export type AuthToken = string | null;
export type RefreshToken = string | null;

export interface User {
  uuid: string;
  username: string;
  phonenumber?: string;
  email?: string;
}

const AUTH_TOKEN = "authToken";
const REFRESH_TOKEN = "refreshToken";
const USER_DATA = "userData";

export const setTokens = (
  authToken?: AuthToken,
  refreshToken?: RefreshToken,
  userData?: User
): void => {
  console.log("💾 [Auth Storage] Setting tokens...");
  console.log("💾 [Auth Storage] User data being stored:", userData);
  console.log("💾 [Auth Storage] User UUID being stored:", userData?.uuid);
  
  if (authToken != null) {
    localStorage.setItem(AUTH_TOKEN, authToken);
  }
  if (refreshToken != null) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
  if (userData != null) {
    localStorage.setItem(USER_DATA, JSON.stringify(userData));
    console.log("💾 [Auth Storage] User data stored successfully");
  }
};

export const getTokens = (): {
  authToken: AuthToken;
  refreshToken: RefreshToken;
  userData: User | null;
} => {
  const authToken = localStorage.getItem(AUTH_TOKEN);
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  const userDataStr = localStorage.getItem(USER_DATA);
  const userData = userDataStr ? JSON.parse(userDataStr) : null;
  
  console.log("🔓 [Auth Storage] Retrieved userData from localStorage:", userData);
  console.log("🔓 [Auth Storage] Retrieved UUID:", userData?.uuid);
  console.log("🔓 [Auth Storage] Retrieved email:", userData?.email);
  
  return {
    authToken,
    refreshToken,
    userData,
  };
};

export const removeTokens = () => {
  console.log("🗑️ [Auth Storage] Removing all tokens from localStorage");
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(USER_DATA);
};
